var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TagButton",on:{"click":_vm.runHole}},[_c('div',{staticClass:"TagButton_image"},[_c('img',{attrs:{"src":_vm.iconUrl,"alt":""}})]),_c('div',{staticClass:"TagButton_text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }